import React, { useEffect, useState } from 'react';
import axios from './config/axios';

import { UsersProvider } from './contexts/usersContext';
import { AuthProvider } from './contexts/AuthContext';
import autoAuthData from './config/authData';

import Layout from './hoc/Layout/Layout';

const App = () => {
  const [usersData, setUsersData] = useState({
    participants: {},
    organizers: {},
    loaded: false
  })

  const [authData, setAuthData] = useState({
    auth: false,
    token: null,
    userId: null,
    expires: null
  })

  useEffect(() => {
    axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDLmUJLhu3Z8sosomrmLJjFVnrLV81-IME', autoAuthData)
      .then(response => {
        const expDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
        setAuthData({
          auth: true,
          token: response.data.idToken,
          userId: response.data.localId,
          expires: expDate
        })
        localStorage.setItem('id', response.data.localId);
        localStorage.setItem('token', response.data.idToken);
        localStorage.setItem('expires', expDate);

        const getUsers = axios.get(`/users.json?auth=${response.data.idToken}`);
        const getOrganizers = axios.get(`/organizers.json?auth=${response.data.idToken}`);

        Promise.all([getUsers, getOrganizers])
          .then(result => {
            const res0 = result[0].data;
            const res1 = result[1].data;

            setUsersData({
              participants: res0,
              organizers: res1,
              loaded: true
            })
          })
      })

  }, [])

  return <UsersProvider value={[usersData, setUsersData]}>
    <AuthProvider value={[authData, setAuthData]} >
      {authData.auth && <Layout />}
    </AuthProvider>
  </UsersProvider>

}

export default App;
